import { createSlice } from '@reduxjs/toolkit';
import { fetchDealerAsync, fetchZipCodeAsync } from './thunk';
import { IDLE_STATUS, LOADING_STATUS } from '../../../../../constants';

export const initialState = {
  status: '',
  defaultZipCode: '',
  zipCode: '',
  errors: false,
  inventoryResult: {},
};

export const getInventory = createSlice({
  name: 'inventory-near-you',
  initialState,
  reducers: {
    setZipCode: (state, { payload }) => {
      state.zipCode = payload;
    },
    setTrim: (state, { payload }) => {
      state.trims = payload;
    },
  },
  extraReducers: (builder) => {

    builder
      .addCase(fetchDealerAsync.pending, (state) => {
        state.status = LOADING_STATUS;
        state.errors = false;
      })
      .addCase(fetchDealerAsync.fulfilled, (state, { payload }) => {
        state.status = IDLE_STATUS;
        if (payload?.success && payload?.result) {
          state.inventoryResult = payload.result;
        } else {
          state.errors = true;
        }
      });
    // builder for fetchZipCodeAsync
    builder
      .addCase(fetchZipCodeAsync.pending, (state) => {
        state.status = LOADING_STATUS;
        state.errors = false;
      })
      .addCase(fetchZipCodeAsync.fulfilled, (state, { payload }) => {
        state.status = IDLE_STATUS;
        if (payload.zip) {
          state.zipCode = payload.zip;
          state.defaultZipCode = payload.zip;
        } else {
          state.errors = true;
        }
      });
  },
});

export { fetchDealerAsync, fetchZipCodeAsync };

export const {
  setZipCode,
} = getInventory.actions;
export default getInventory.reducer;